import { LOGIN_METHOD } from "../../../../constants";

export const LINE_PHONE_METHODS = [
  LOGIN_METHOD.LINE_PHONE_NUMBER,
  LOGIN_METHOD.LINE_ADCOINZ_PHONE_NUMBER,
];

export const LINE_SESSION_METHODS = [
  LOGIN_METHOD.LINE_SESSION_ID,
  LOGIN_METHOD.LINE_ADCOINZ_SESSION_ID,
  LOGIN_METHOD.LINE_TW,
];

export const LINE_LIFF_METHODS = [
  LOGIN_METHOD.LINE_LIFF_SR,
  LOGIN_METHOD.LINE_LIFF_ADCOINZ,
  LOGIN_METHOD.LINE_LIFF_TAIWAN
];

export const LINE_NO_PHONE_METHODS = [
  LOGIN_METHOD.LINE_SSO,
  LOGIN_METHOD.LINE_SESSION_ID,
  LOGIN_METHOD.LINE_ADCOINZ_SESSION_ID,
  LOGIN_METHOD.LINE_TW,
  ...LINE_LIFF_METHODS
];

export const LINE_ALL_METHODS = [
  LOGIN_METHOD.LINE_SSO,
  ...LINE_PHONE_METHODS,
  ...LINE_SESSION_METHODS,
  ...LINE_LIFF_METHODS
];

export const WHATSAPP_METHODS = [
  LOGIN_METHOD.WHATSAPP,
  LOGIN_METHOD.TWILIO_WHATSAPP,
];

export const isLineMethod = (method: string) =>
  LINE_ALL_METHODS.includes(method);

export const isLineSessionMethod = (method: string) =>
  LINE_SESSION_METHODS.includes(method);

export const isWhatsappMethod = (method: string) =>
  WHATSAPP_METHODS.includes(method);
